/**
 * Image widths used internally, kept separate so we can keep this list lean
 */
export interface ImageWidths {
    thewest: 110 | 150 | 268 | 500 | 810 | 860 | 1224
    perthnow: 88 | 106 | 150 | 320 | 668 | 736 | 984
    sevennews: 126 | 320 | 650
}

// Combined ImageWidth Type
export type ImageWidth = ImageWidths['thewest'] | ImageWidths['perthnow'] | ImageWidths['sevennews']

export let imagePolicy: string | undefined

export const setImageManagerPolicy = (policy: string) => {
    imagePolicy = policy
}
